/* unplugin-vue-components disabled */import { render } from "./dspop.vue?vue&type=template&id=c6afd11e&scoped=true"
import script from "./dspop.vue?vue&type=script&lang=js"
export * from "./dspop.vue?vue&type=script&lang=js"

import "./dspop.vue?vue&type=style&index=0&id=c6afd11e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6afd11e"]])

export default __exports__